module.exports = __webpack_public_path__ + "static/s3-3-infrastructure-d-80012b0573261590a4b6aac9c890de91.jpg";